import React, { useEffect, useState } from 'react';
import graph from './graph';
import schema from './schema';
import uiSchema from './uiSchema';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { isEmptyObject } from 'helpers/formatObject';
import { addCommas } from '@persian-tools/persian-tools';
import { useLazyQuery, useMutation } from '@apollo/client';
import { CircularProgress, Stack, Button, Typography } from '@mui/material';
import { NewDialog, MuiFormBuilder, NewDialogTitle, NewDialogContent, NewDialogActions, CustomList } from 'components';

export default function UpdateProduct({ id, refetch, title = 'ایجاد محصول' }) {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const { userToken } = useSelector((state) => state.auth);
  const [fetchModel, { loading }] = useLazyQuery(graph.get.query);
  const [updateModel, { loading: updating }] = useMutation(graph.update.query);

  const onOpen = () => setOpen(true);
  const onClose = () => setOpen(false);

  const getModel = async () => {
    try {
      const { data } = await fetchModel({
        context: {
          serviceName: graph.get.serviceName,
          headers: {
            authorization: `Bearer ${userToken}`,
          },
        },
        variables: {
          ids: id,
        },
      });
      if (!isEmptyObject(data)) {
        const res = data[graph.get.name]?.import_error_records.data[0];
        const {
          shop,
          title,
          barcode,
          co_price,
          me_price,
          introtext,
          description,
          brand_title,
          booth_title,
          category_title,
        } = res;
        if (res) {
          setFormData({
            title,
            barcode,
            introtext,
            barcodes: barcode,
            shop_id: shop?.id,
            me_price: Number(me_price),
            co_price: Number(co_price),
            description,
            brand_title,
            booth_title,
            category_title,
          });
        }
      }
    } catch (error) {}
  };

  const onSubmit = async ({ formData }) => {
    try {
      const { data, errors } = await updateModel({
        context: {
          serviceName: graph.update.serviceName,
          headers: {
            authorization: `Bearer ${userToken}`,
          },
        },
        variables: {
          import_error_id: id,
          ...formData,
        },
      });
      if (!errors) {
        refetch();
        onClose();
        if (!isEmptyObject(data)) {
          data[graph.update.name]?.messages.map((message) => toast.success(String(message)));
        }
      }
    } catch (error) {
      setFormData(formData);
    }
  };

  useEffect(() => {
    open && getModel();
  }, [open]);

  return (
    <>
      <Button size="small" color="info" variant="outlined" onClick={onOpen}>
        بررسی
      </Button>
      <NewDialog open={open} onClose={onClose}>
        <NewDialogTitle title={title} onClose={onClose} />
        <NewDialogContent isPopup>
          <Stack p={1} flex={1} rowGap={1} bgcolor="background.paper">
            {loading ? (
              <Stack rowGap={2} height="100%" alignItems="center" justifyContent="center">
                <CircularProgress size={20} color="inherit" />
                <Typography align="center" variant="caption" color="text.disabled">
                  در حال بارگذاری...
                </Typography>
              </Stack>
            ) : (
              <>
                <CustomList
                  data={{
                    title: formData?.title,
                    children: [
                      {
                        title: 'برند',
                        value: formData?.brand_title,
                      },
                      {
                        title: 'غرفه',
                        value: formData?.booth_title,
                      },
                      {
                        title: 'دسته بندی',
                        value: formData?.category_title,
                      },
                      {
                        title: 'قیمت محصول',
                        value: addCommas(Number(formData?.co_price)),
                        unit: 'تومان',
                      },
                      {
                        title: 'قیمت فروشگاه',
                        value: addCommas(Number(formData?.me_price)),
                        unit: 'تومان',
                      },
                      {
                        title: 'توضیحات',
                        value: formData?.description,
                      },
                    ],
                  }}
                />
                <MuiFormBuilder
                  id="submit"
                  showSubmit={false}
                  liveValidate={false}
                  schema={schema()}
                  uiSchema={uiSchema()}
                  formData={formData}
                  onSubmit={onSubmit}
                />
              </>
            )}
          </Stack>
        </NewDialogContent>
        <NewDialogActions>
          <Button
            autoFocus
            fullWidth
            size="large"
            type="submit"
            form="submit"
            variant="contained"
            disabled={loading || updating}
          >
            {title}
          </Button>
        </NewDialogActions>
      </NewDialog>
    </>
  );
}
